<!--
  Tiny pathname/hash check in place of vue-router: '/oauth/callback' completes the OAuth flow, '/open?s=<token>' is
  the ChatGPT handoff (restores a session from workers/lite-mcp and opens the Open in Nanome dialog), everything else
  is the viewer.
-->
<script setup lang="ts">
import { ref } from 'vue';
import { isOAuthCallbackUrl } from '@/open-in-nanome/oauth';
import { handoffTokenFromUrl } from '@/session/handoff';
import Viewer from '@/views/Viewer.vue';
import OAuthCallback from '@/views/OAuthCallback.vue';

const route = ref<'viewer' | 'oauth-callback'>(isOAuthCallbackUrl() ? 'oauth-callback' : 'viewer');
const openInNanomeOnMount = ref(false);
const handoffToken = handoffTokenFromUrl();

function onCallbackDone() {
  openInNanomeOnMount.value = true;
  route.value = 'viewer';
}
</script>

<template>
  <OAuthCallback v-if="route === 'oauth-callback'" @done="onCallbackDone" />
  <Viewer v-else :open-in-nanome-on-mount="openInNanomeOnMount" :handoff-token="handoffToken" />
</template>
